import { Grid, GridItem, Icon } from '@chakra-ui/react';
import { FiAlertTriangle } from 'react-icons/fi';

export function AlertTime({ transpPrazo }) {
  return (
    <Grid
      gridTemplateColumns="repeat(12, 1fr)"
      color="white"
      bgColor="#2C2C3A"
      fontSize="12px"
      textTransform="uppercase"
      fontWeight="bold"
      p={3}
      placeItems="center">
      <GridItem gridColumn="span 3" display="flex" alignItems="center" gap={2}>
        <Icon as={FiAlertTriangle} color="white" fontSize="20px" />
        Importante
      </GridItem>
      <GridItem gridColumn="span 9">
        Caso o pedido não seja aprovado dentro desse periodo, o seu prazo de produção será
        prorrogado para o dia {transpPrazo} automaticamente.
      </GridItem>
    </Grid>
  );
}
